import {FolderList} from "../utils/FolderList";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import SchoolIcon from "@mui/icons-material/School";
import * as React from "react";

export const FList = () => {
    return (
        <FolderList lists={[
            {icon: <CalendarMonthIcon/>, primary: "Тренировка", secondary: "Ты решаешь реальные задачи экзамена"},
            {
                icon: <AutoGraphIcon/>,
                primary: "Анализ",
                secondary: "ИИ анализирует твои слабые места и подгоняет индивидуальную программу"
            },
            {
                icon: <ModelTrainingIcon/>,
                primary: "Обучение",
                secondary: "Ты проходишь эту программу и укрепляешь слабые места"
            },
            {icon: <SchoolIcon/>, primary: "Экзамен", secondary: "Сдаешь экзамен на максимум баллов"},
        ]}/>
    )
}
